import React, { useState, useEffect } from 'react'
import { SelectBox } from '@tecuity/granite-ui'
import './CustomCorrespondenceOptions.scss'
import { useDispatch } from 'react-redux'
import * as api from 'requests'
import { SET_SETTINGS_LIST, SET_OPTIONAL_DATA } from '../../SettingsReducer'
import { useSelector, shallowEqual } from 'react-redux'
import { Spinner } from 'components/Loaders/Loaders'

const RegulatedWordsOptions = () => {
  const dispatch = useDispatch()
  const { optionalData } = useSelector((state) => state.settings, shallowEqual)
  const [recordTypeOptions, setRecordTypeOptions] = useState([
    { label: 'List All Words', value: '-1' },
    { label: 'Global', value: '0' },
  ])
  const [recordSubTypeOptions, setRecordSubTypeOptions] = useState([
    { label: 'List All Words', value: '-1' },
    { label: 'Global', value: '0' },
  ])
  const [wordTypeOptions, setWordTypeOptions] = useState([{ label: 'All', value: '0' }])
  const [recordType, setRecordType] = useState(optionalData.recordType || 0)
  const [recordSubType, setRecordSubType] = useState(optionalData.recordSubType || 0)
  const [wordType, setWordType] = useState(optionalData.wordType || 0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    api.GET_SETTINGS_REGULATED_WORDS_BY_TYPES_AND_CATEGORY(
      169, // Business Source Type Id
      recordType,
      recordSubType,
      wordType,
      (res) => {
        dispatch({
          type: SET_SETTINGS_LIST,
          settingsList: res
            .map((item) => ({
              ...item,
              Id: item.RegulatedWordId,
              Name: `${item.RegulatedWordTypeName} - ${item.Word}`,
            }))
            .sort((a, b) => (a.Name > b.Name ? 1 : -1)),
        })
        api.GET_BUSINESS_RECORD_SUB_TYPE_XREFS_BY_RECORD_TYPE(
          recordType,
          (xrefRes) => {
            // dispatch({ type: SET_SETTINGS_LIST, settingsList: res })
            dispatch({
              type: SET_OPTIONAL_DATA,
              optionalData: {
                recordSubTypeXrefs: xrefRes.BusinessRecordSubTypeIds,
                recordType,
                recordSubType,
                wordType,
              },
            })
            setLoading(false)
          },
          (err) => {
            console.error('retrieving', err)
            setLoading(false)
          }
        )
      },
      (err) => {
        console.error('retrieving', err)
        setLoading(false)
      }
    )
  }, [recordType, recordSubType, wordType])

  const getRecordTypeRecordSubTypeOptions = () => {
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'Business',
      'RecordSubType',
      (res) =>
        setRecordSubTypeOptions([
          { label: 'List All Words', value: '-1' },
          { label: 'Global', value: '0' },
          ...res
            .map((t) => ({
              value: t.Id,
              label: t.Name,
            }))
            .sort((a, b) => a['label'].localeCompare(b['label'])),
        ]),
      (err) => {
        setRecordTypeOptions([
          { label: 'List All Words', value: '-1' },
          { label: 'Global', value: '0' },
        ])
        setRecordSubTypeOptions([
          { label: 'List All Words', value: '-1' },
          { label: 'Global', value: '0' },
        ])
        console.error(err.message)
      }
    )
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'Business',
      'RecordType',
      (res) =>
        setRecordTypeOptions([
          { label: 'List All Words', value: '-1' },
          { label: 'Global', value: '0' },
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name,
          })),
        ]),
      (err) => {
        setRecordTypeOptions([
          { label: 'List All Words', value: '-1' },
          { label: 'Global', value: '0' },
        ])
        setRecordSubTypeOptions([
          { label: 'List All Words', value: '-1' },
          { label: 'Global', value: '0' },
        ])
        console.error(err.message)
      }
    )
    api.GET_REGULATED_WORD_TYPES(
      (res) => {
        setWordTypeOptions([
          { label: 'All', value: '0' },
          ...res
            .sort((a, b) => (a.Name > b.Name ? 1 : -1))
            .map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
        ])
      },
      (err) => {
        console.error(err)
      }
    )
  }

  useEffect(() => {
    getRecordTypeRecordSubTypeOptions()
  }, [])

  return (
    <div className="custom-correspondence-options">
      <SelectBox
        label="Business Record Type"
        noPlaceholder
        value={recordType}
        onChange={(val) => {
          setRecordType(val)
          setRecordSubType(+val === -1 ? -1 : 0)
        }}
        options={recordTypeOptions}
      />
      <SelectBox
        label="Business Record Sub Type"
        noPlaceholder
        value={recordSubType}
        onChange={(val) => {
          setRecordSubType(val)
        }}
        options={recordSubTypeOptions.filter(
          (item) =>
            +item.value === -1 ||
            +item.value === 0 ||
            (optionalData.recordSubTypeXrefs || []).includes(+item.value)
        )}
        disabled={+recordType === 0 || +recordType === -1}
      />
      <SelectBox
        label="Regulated Word Type"
        noPlaceholder
        value={wordType}
        onChange={(val) => {
          setWordType(val)
        }}
        options={wordTypeOptions}
      />
      {loading && (
        <div className="type-loader">
          <Spinner size="small" themeColor="dark-neutral" />
        </div>
      )}
    </div>
  )
}

export default RegulatedWordsOptions
